var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegral(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32C35.314 32 38 34.686 38 38C38 41.314 35.314 44 32 44C28.686 44 26 41.314 26 38C26 34.686 28.686 32 32 32ZM12 24C16.42 24 20 27.58 20 32C20 36.42 16.42 40 12 40C7.58 40 4 36.42 4 32C4 27.58 7.58 24 12 24ZM32 36C30.896 36 30 36.896 30 38C30 39.104 30.896 40 32 40C33.104 40 34 39.104 34 38C34 36.896 33.104 36 32 36ZM12 28C9.79 28 8 29.79 8 32C8 34.21 9.79 36 12 36C14.21 36 16 34.21 16 32C16 29.79 14.21 28 12 28ZM29 4C35.076 4 40 8.924 40 15C40 21.076 35.076 26 29 26C22.924 26 18 21.076 18 15C18 8.924 22.924 4 29 4ZM29 8C25.134 8 22 11.134 22 15C22 18.866 25.134 22 29 22C32.866 22 36 18.866 36 15C36 11.134 32.866 8 29 8Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegral);
export default __webpack_public_path__ + "static/media/integral.6d25bdd6ee03b8e35c901bef1eecbb5b.svg";
export { ForwardRef as ReactComponent };